import { MODULE_CONTENT_KEY } from '@/domains/chat/types';

/** 所有模块 key 的对象（用于校验、遍历等，数据存取使用 version_number + module_key） */
export const ALL_MODULE_KEYS: Record<string, boolean> = {
    // step 1
    [MODULE_CONTENT_KEY.SYSTEM_COMPONENT_ANALYSIS]: true,
    [MODULE_CONTENT_KEY.COMPONENT_TOUCH_ANALYSIS]: true,
    [MODULE_CONTENT_KEY.FUNCTIONAL_MODELING]: true,
    [MODULE_CONTENT_KEY.SYSTEM_STRUCTURE_ANALYSIS]: true,
    [MODULE_CONTENT_KEY.FIRST_STEP_PROBLEM_SUMMARY]: false,

    // step 2
    [MODULE_CONTENT_KEY.CAUSAL_CHAIN_ANALYSIS]: true,
    [MODULE_CONTENT_KEY.SECOND_STEP_PROBLEM_SUMMARY]: false,

    // step 3
    [MODULE_CONTENT_KEY.BATCH_PATENT_RECALL]: true,
    [MODULE_CONTENT_KEY.BATCH_PATENT_TRIZ_FEATURES]: false,
    [MODULE_CONTENT_KEY.BATCH_SOLUTION_IDEAS]: true,

    // step 4
    [MODULE_CONTENT_KEY.SOLUTION_REFINE_ANALYSIS]: false,
    [MODULE_CONTENT_KEY.SOLUTION_VALIDATION_ANALYSIS]: false,
    [MODULE_CONTENT_KEY.SOLUTION_NOVELTY_ANALYSIS]: false,
    [MODULE_CONTENT_KEY.SOLUTION_IMAGE]: false,
    [MODULE_CONTENT_KEY.SOLUTION_VIDEO]: false,
    [MODULE_CONTENT_KEY.SOLUTION_FLOWCHART]: false,
};
